import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import { Divider} from '@mui/material';
import InfoItemBox from './InfoItemBox';
import { InfoItemBoxProps } from '../dataObjects/contentTypes';


const content: InfoItemBoxProps[] =  [
    {
      title: "Commence Recordkeeping and Reporting",
      blocks: [
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              content: "Once your committee is established, you will report your campaign finance activity. Your reports will be submitted to your local election official. You will need to contact your local election official for your reporting schedule."
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              content: "You can use this form to file campaign finance activity: "
            },
            {
              type: "link",
              text: "CPF M 102: Municipal Campaign Finance Report",
              url: "https://ocpf2.blob.core.windows.net/pdf/forms/cpf_m102.pdf"
            },
            {
              type: "text",
              content: " ("
            },
            {
              type: "link",
              text: "Editable version",
              url: "https://ocpf2.blob.core.windows.net/pdf/forms/M102_edit.pdf"
            },
            {
              type: "text",
              content: ") ("
            },
            {
              type: "link",
              text: "Instructions",
              url: "https://ocpf2.blob.core.windows.net/pdf/forms/instr_cpf_m102.pdf"
            },
            {
              type: "text",
              content: ")."
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              content: "Candidates and committees must maintain detailed accounts of all contributions received and all expenditures made. These records must be kept separate and distinct from any other accounts or records and must be preserved for 6 years from the relevant election."
            }
          ]
        }
      ]
    },
    {
      title: "Use OCPF Reporter 7 to Create and Print Campaign Finance Reports",
      blocks: [
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              content: "Local filers can use R7 (Reporter 7) to create, print, sign and file campaign finance reports. "
            },
            {
              type: "link",
              text: "Click here",
              url: "https://www.youtube.com/watch?v=49A1EW6iARg"
            },
            {
              type: "text",
              content: " for a short instructional video."
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              content: "Please click ",
              isBold: true
            },
            {
              type: "link",
              text: "here",
              url: "https://ocpfreporter.us/LocalFilerSignup",
              isBold: true
            },
            {
              type: "text",
              content: " to register to use R7.",
              isBold: true
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              content: '"Local filers" include all town candidates, and all city candidates who don\'t e-file with OCPF.'
            }
          ]
        }
      ]
    },
    {
      title: "Additional Help & Information",
      blocks: [
        {
          type: "list",
          listType: "bullet",
          items: [
            {
              content: [
                {
                  type: "text",
                  content: "Campaign Finance "
                },
                {
                  type: "link",
                  text: "Guide",
                  url: "Guide"
                },
                {
                  type: "text",
                  content: ": Candidates for Municipal Office."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "Campaign Finance "
                },
                {
                  type: "link",
                  text: "Guide",
                  url: "Guide"
                },
                {
                  type: "text",
                  content: ": Municipal Ballot Question Committees."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "Campaign Finance "
                },
                {
                  type: "link",
                  text: "Guide",
                  url: "Guide"
                },
                {
                  type: "text",
                  content: ": Political Action Committees (PACs) and People's Committees."
                }
              ]
            },
            {
              content: [
                {
                  type: "link",
                  text: "Common errors",
                  url: "Common errors"
                },
                {
                  type: "text",
                  content: " to avoid when filing."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "Contribution Limits "
                },
                {
                  type: "link",
                  text: "Chart",
                  url: "/Legal/ContributionLimits"
                },
                {
                  type: "text",
                  content: "."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "Public Employees and Campaigns: A "
                },
                {
                  type: "link",
                  text: "Fact Sheet",
                  url: "Fact Sheet"
                },
                {
                  type: "text",
                  content: "."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "OCPF Guide: "
                },
                {
                  type: "link",
                  text: "Reporting Out-of-Pocket Campaign Expenditures",
                  url: "Reporting Out-of-Pocket Campaign Expenditures"
                },
                {
                  type: "text",
                  content: "."
                }
              ]
            }
          ]
        }
      ]
    }
  ];


const LocalFilerInfo = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  return (
      <div>
 
        <Typography
              component="h1"
              variant="h4"
              align={'left'}
              data-aos={'fade-up'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
              paddingTop={4}>
              Local Filers: How to Prepare and File Reports 
            </Typography>

            <Divider />
        
         {content.map((content, index) => (
          <InfoItemBox key={index} {...content} />
        ))}
      </div>
       
   
        
  );
};

export default LocalFilerInfo;
